export interface Annotation {
    id: string;
    projectId: string;
    taskId: string;
    taskName?: string;
    workflowArea?: string;
    content: string;
    createdAt: string;
    createdBy: string;
    mentions?: string[];
}
